import React, { useCallback } from 'react'
import VideoDuration from 'Components/video/video-duration'
import VideoSize from 'Components/video/video-size'
import AuthorAvatar from 'Components/author/author-avatar'
import VideoStats from 'Components/video/video-stats'
import formatDuration from 'lib/format-duration'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Image, ImageStyles, ImageZoom } from 'Components/view-image'

interface IProps {
  order?: number
  category: string
  className?: string
  uniqueIdStr: string
  title: string
  coverUrl: string
  duration: number
  avatar: string
  name: string
  videoWatchCount: number
  publishTime: number
  userId: string
  [key: string]: any
}

const Item: React.FC<IProps> = ({
  order,
  category,
  uniqueIdStr,
  title,
  coverUrl,
  duration,
  avatar,
  name,
  className,
  userVerified,
  verifyType,
  userId,
  videoWatchCount,
  publishTime,
  authorTeaParams,
  contentTeaParams,
  ...props
}) => {
  const handleClick = useCallback(() => {
    if (!contentTeaParams) {
      return
    }
    sendTeaCommEvent(
      'clk_event',
      Object.assign(
        {
          category_name: category,
          group_id: uniqueIdStr,
          rank: `${order}`,
        },
        contentTeaParams
      )
    )
  }, [uniqueIdStr, category, order, contentTeaParams])

  return (
    <div className={`feed-item ${className ? className : ''}`} {...props}>
      <div className="image-wrap">
        <a
          className="image-link"
          href={`/article/${uniqueIdStr}`}
          // eslint-disable-next-line react/jsx-no-target-blank
          target="_blank"
          rel="noopener noreferrer"
        >
          <ImageZoom zoomHeight="56.25%" onClick={handleClick}>
            <Image
              src={coverUrl}
              width={512}
              height={288}
              lazy={true}
              alt={title}
              className="motor-pc-image-hover"
            />
          </ImageZoom>
        </a>
        {duration > 0 && (
          <VideoDuration
            duration={formatDuration(duration)}
            style={{ position: 'absolute', right: 8, bottom: 8 }}
          />
        )}
        <AuthorAvatar
          avatar={avatar}
          username={name}
          userVerified={userVerified}
          verifyType={verifyType}
          userId={userId}
          onClick={() => {
            if (!authorTeaParams) {
              return
            }
            sendTeaCommEvent(
              'clk_event',
              Object.assign(
                {
                  category_name: category,
                  group_id: uniqueIdStr,
                  user_id: `${userId}`,
                },
                authorTeaParams
              )
            )
          }}
        />
      </div>
      <a
        className="info-bottom"
        onClick={handleClick}
        href={`/article/${uniqueIdStr}`}
        // eslint-disable-next-line react/jsx-no-target-blank
        target="_blank"
        rel="noopener noreferrer"
      >
        <div title={title} className="title line-2 g-active-link-text">
          {title}
        </div>
        <VideoStats
          playNums={videoWatchCount}
          publishTime={publishTime}
          postUnit={duration > 0 ? '次播放' : '次阅读'}
        />
      </a>
      <style jsx>
        {`
          .feed-item {
            overflow: hidden;
            position: relative;
          }
          .feed-item:last-child {
            margin-right: 0;
          }
          .image-wrap {
            position: relative;
          }
          .image-link {
            border-radius: 2px;
            display: block;
            line-height: 0;
            overflow: hidden;
          }
          .info-bottom {
            display: block;
            padding: 33px 8px 15px;
          }
          .title {
            font-size: 16px;
            font-weight: 500;
            color: #1f2129;
          }
          .feed-item:hover .image-link {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
          }
          .feed-item:hover .info-bottom {
            background: #fff;
            padding: 33px 8px 15px;
          }
          :global(.home-feed-card .feed-item .common-image-zoom img) {
            object-fit: cover;
          }
        `}
      </style>
    </div>
  )
}

export default Item
